import { render, staticRenderFns } from "./PostScribeScript.vue?vue&type=template&id=2313e2fc&"
import script from "./PostScribeScript.vue?vue&type=script&lang=js&"
export * from "./PostScribeScript.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports